var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseNoFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.125 0.895803C26.7358 0.505694 26.2073 0.286458 25.6562 0.286458C25.1052 0.286458 24.5767 0.505694 24.1875 0.895803L14 11.0625L3.8125 0.87497C3.42327 0.48486 2.89483 0.265625 2.34375 0.265625C1.79267 0.265625 1.26423 0.48486 0.875 0.87497C0.0625 1.68747 0.0625 2.99997 0.875 3.81247L11.0625 14L0.875 24.1875C0.0625 25 0.0625 26.3125 0.875 27.125C1.6875 27.9375 3 27.9375 3.8125 27.125L14 16.9375L24.1875 27.125C25 27.9375 26.3125 27.9375 27.125 27.125C27.9375 26.3125 27.9375 25 27.125 24.1875L16.9375 14L27.125 3.81247C27.9167 3.0208 27.9167 1.68747 27.125 0.895803Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseNoFill);
export default __webpack_public_path__ + "static/media/close-no-fill.d9780b029f613a821fb6df23863b2656.svg";
export { ForwardRef as ReactComponent };